import { render, staticRenderFns } from "./FavorabilityIcon.vue?vue&type=template&id=3d48a048&scoped=true"
import script from "./FavorabilityIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./FavorabilityIcon.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48a048",
  null
  
)

export default component.exports